var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2501 8.74998H25.2651M9.50001 2H24.5001C28.6422 2 32 5.35786 32 9.49999V24.4999C32 28.642 28.6422 32 24.5001 32H9.50001C5.35787 32 2 28.642 2 24.4999V9.49999C2 5.35786 5.35787 2 9.50001 2ZM23 16.055C23.1852 17.3033 22.9719 18.5783 22.3907 19.6985C21.8095 20.8187 20.8897 21.7271 19.7625 22.2944C18.6352 22.8617 17.3577 23.0594 16.1117 22.8589C14.8657 22.6584 13.7147 22.0701 12.8223 21.1777C11.9299 20.2853 11.3416 19.1343 11.1411 17.8883C10.9406 16.6423 11.1381 15.3648 11.7055 14.2375C12.2729 13.1103 13.1813 12.1906 14.3015 11.6093C15.4217 11.0281 16.6967 10.8149 17.945 11C19.2184 11.1888 20.3974 11.7822 21.3076 12.6924C22.2178 13.6027 22.8112 14.7816 23 16.055Z",
    stroke: "#C1C6D7",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.0ae4c6002c3456cbd0a07acf5deb6620.svg";
export { ForwardRef as ReactComponent };